/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, IconButton, Switch } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  useLazyDeleteCustomerQuery,
  useLazyGetCustomersQuery,
  useUpdateStatusCustomerMutation,
} from "../../services/customer";
import { ROLES } from "../../utils/enums";
import { SubAdmin, SubAdminResponse } from "../../types/General";
import { showError, showToast } from "../../constants/toasts";
import moment from "moment";
import { handleDelete } from "../../utils/commonFunctions";
import { ConfirmationModal } from "../../Modals/confirmationModal";

const SubadminList = ({
  debouncedSearchTerm,
}: {
  debouncedSearchTerm: string;
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState<number>(1);
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [openDelete, setOpenDelete] = useState(false);
  const [rows, setRows] = useState<SubAdminResponse[]>([]);
  const [getCustomers] = useLazyGetCustomersQuery();
  const [updateStatus] = useUpdateStatusCustomerMutation();
  const [deleteCustomer] = useLazyDeleteCustomerQuery();

  const label = { inputProps: { "aria-label": "Switch demo" } };

  // const rows = [
  //     {
  //         id: 1,
  //         email: "david@yopmail.com",
  //         phone: "9876543210",
  //         date: "01 March 2025",
  //         role: "Role 1"
  //     },
  //     {
  //         id: 2,
  //         email: "david@yopmail.com",
  //         phone: "9876543210",
  //         date: "01 March 2025",
  //         role: "Role 1"
  //     },
  //     {
  //         id: 3,
  //         email: "david@yopmail.com",
  //         phone: "9876543210",
  //         date: "01 March 2025",
  //         role: "Role 1"
  //     },
  //     {
  //         id: 4,
  //         email: "david@yopmail.com",
  //         phone: "9876543210",
  //         date: "01 March 2025",
  //         role: "Role 1"
  //     },
  //     {
  //         id: 5,
  //         email: "david@yopmail.com",
  //         phone: "9876543210",
  //         date: "01 March 2025",
  //         role: "Role 1"
  //     },
  // ];
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 180,
      field: "name",
      headerName: "Name",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div
            className="user_block click_action"
            onClick={() => navigate(`/manage-subadmin/detail/${row._id}`)}
          >
            <figure>
              <img
                src={
                  row?.image
                    ? row?.image
                    : `/static/images/user_placeholder.png`
                }
                alt=""
              />
            </figure>
            <p>
              <b>{row?.fullName}</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 180,
      field: "email",
      headerName: "Email",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 180,
      field: "phone",
      headerName: "Phone Number",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          //@ts-ignore
          <p>
            {row?.countryCode || ""} {row?.phone || ""}
          </p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "acceessRole",
      headerName: "Role",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          //@ts-ignore
          <p>{row.acceessRole?.[0].name}</p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "createdAt",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <p>
            <b>{moment(row?.createdAt).format("YYYY-MM-DD")}</b>
          </p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            checked={!row?.isBlocked}
            onChange={() => handleStatusChange(row?._id, row?.isBlocked)}
          />
        );
      },
    },
    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton
                onClick={() => navigate(`/manage-subadmin/detail/${row?._id}`)}
              >
                <img src="/static/images/eye_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton
                onClick={() => navigate(`/manage-subadmin/edit/${row?._id}`)}
              >
                <img src="/static/images/edit2_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedId(row?._id);
                  setOpenDelete(true);
                }}
              >
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];
  let hidden = ["fullName"];

  const handleStatusChange = async (id: string, status: boolean) => {
    const body = {
      isBlocked: !status,
      userId: id,
    };

    try {
      setIsLoading(true);
      let response;

      response = await updateStatus(body).unwrap();

      if (response?.statusCode === 200) {
        showToast("Status updated successfully");
        //   navigate('/manage-subadmin')
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    } finally {
      setIsLoading(false);
      getAllSubAdmin();
    }
  };

  const getAllSubAdmin = async () => {
    setIsLoading(true);
    try {
      const response = await getCustomers({
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
        role: ROLES.SUB_ADMIN,
        // status:0
      }).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        setRows(response?.data?.list || []);
        setCount(response?.data?.totalCount);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleDelete = async () => {
    setIsLoading(true);
    const body = {
      userId: selectedId,
    };
    try {
      const response = await deleteCustomer(body).unwrap();
      setIsLoading(false);

      if (response?.statusCode === 200) {
        showToast("Sub-Admin Deleted successfully");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setIsLoading(false);
    } finally {
      getAllSubAdmin();
    }
  };

  useEffect(() => {
    getAllSubAdmin();
  }, [debouncedSearchTerm]);

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
          count={count}
          page={page}
          onPageChange={handlePageChange}
          loading={isLoading}
        />
      </div>
      <ConfirmationModal
        text="Are you sure to delete this sub-admin"
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={handleDelete}
      />
    </>
  );
};

export default SubadminList;
